const variantName = 'galleryV1a'

export default {
  [variantName]: {
    // ?============================
    // ?======  Containers =========
    // ?============================

    container: {
      padding: '3rem 1rem',
      width: '100%'
    },
    wrapper: {
      width: '100%'
    },

    // ?============================
    // ?====  Albums Containers ====
    // ?============================

    albumsContainer: {
      width: '100%',
      flexWrap: 'wrap',
      justifyContent: 'center'
    },
    albumsCTA: {
      width: ['100%', '48%', '24%'],
      margin: [0, '1%'],
      marginBottom: ['1%'],
      height: '300px',
      cursor: 'pointer',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    },

    albumTitle: {
      color: 'white',
      textShadow: '2px 2px black',
      fontSize: 5,
      textAlign: 'center'
    },

    // ?============================
    // ?=====  Album Container =====
    // ?============================

    albumContainer: {
      flexWrap: 'wrap',
      alignItems: 'stretch',
      margin: '1rem auto',
      justifyContent: 'center',
      gridGap: 4,
      gridTemplateColumns: 'repeat( auto-fill, minmax( 300px, 1fr ) )',
      gridAutoRows: '100px',
      padding: 4,
      display: 'grid !important'
    },
    albumImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      padding: 1
    }
  }
}
